import { WplywContext } from "../../../../../../../context/wplywContext";
import { useContext } from "react";
import LineSpacer from "../../../../../../../components/LineSpacer";
import { Button, Modal, Spin } from "antd";
import formatAccountNumber from "../../../../../../../components/formatAccountNumber";
import { useState } from "react";
import axios from "../../../../../../../context/axiosConfig";
import { useAuth } from "../../../../../../../context/AuthContext";
import WplywSumUp from "../components/WplywSumUp";
import formatPrice from "../../../../../../../components/formatPrice";
import GeneratePersonRaport from "../../../../MainWrapper/GeneratePersonRaport";
import LinkToSumUp from "../../../../MainWrapper/LinkToSumUp";
import isCan from "../../../../../../../components/isCan";
import { useEffect } from "react";
const Transfer = ({ selectedPerson, transfer, index, deepLink }) => {
	const { wplyw, setWplyw } = useContext(WplywContext);
	const [open, setOpen] = useState(() => {
		const deepPersonId = deepLink?.personid;
		const deepTransferId = deepLink?.transferid;
		// If deep-linked to a specific transfer -> open only that one.
		if (deepTransferId) {
			return (
				String(transfer?.msr_transfers_own_id) ===
				String(deepTransferId)
			);
		}
		// If deep-linked only to a person -> open all payouts for that person.
		if (deepPersonId) return true;
		// Default behaviour (no deep-link): keep existing UX (expanded).
		return true;
	});
	const [isGeneratingTransfer, setIsGeneratingTransfer] = useState(false);
	const [cando, setCando] = useState(false); // Stan dla uprawnień
	const [canGenerateXml, setCanGenerateXml] = useState(false);
	const { user } = useAuth();
	const updatedTransfertitle = `Świadczenie dla ${selectedPerson.msr_persons_name} ${selectedPerson.msr_persons_lastname} PRZELEW.ID ${wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_own_id}.${selectedPerson.msr_persons_own_id}.${transfer.msr_transfers_own_id} ${transfer.msr_transfers_title_suffix}`;
	const labelStyle = {
		color: "black",
		fontWeight: "500",
		fontSize: "16px",
		marginBottom: "8px",
	};

	const perms = user.perms;

	// Użycie useEffect do ustawiania wymaganych uprawnień
	useEffect(() => {
		const fetchPermissions = async () => {
			const [confirmResult, generateResult] = await Promise.all([
				isCan(["can_confirm_transfers"], perms),
				isCan(["can_generate_xml"], perms),
			]);
			setCando(confirmResult);
			setCanGenerateXml(generateResult);
		};
		fetchPermissions();
	}, [perms]);

	const GenerateTransfer = async () => {
		if (!transfer?.msr_transfers_id) return;
		setIsGeneratingTransfer(true);
		try {
			const response = await axios.post("/przelewy/generate/xml", {
				ids: [transfer.msr_transfers_id],
				user: user.user.mlg_users_id,
			});

			const fileobject = await axios.post(
				"/przelewy/download/xml",
				{ filename: response?.data?.data },
				{ responseType: "blob" },
			);

			const blob = new Blob([fileobject.data], {
				type: "application/xml",
			});
			const link = document.createElement("a");
			link.href = window.URL.createObjectURL(blob);
			link.download = response?.data?.data || "przelew.xml";
			document.body.appendChild(link);
			link.click();
			link.remove();

			setWplyw({ ...wplyw, reload: !wplyw.reload });
		} catch (error) {
			console.error("Error generating transfer XML:", error);
		} finally {
			setTimeout(() => {
				setIsGeneratingTransfer(false);
			}, 500);
		}
	};

	const ConfirmTransfer = async () => {
		try {
			await axios.post("/wplyw/confirm/transfer", {
				transferid: transfer.msr_transfers_id,
				userid: user.user.mlg_users_id,
			});
			setWplyw({ ...wplyw, reload: !wplyw.reload });
		} catch (error) {
			console.error("Error confirming transfer:", error);
		}
	};
	const UnconfirmTransfer = async () => {
		try {
			await axios.post("/wplyw/unconfirm/transfer", {
				transferid: transfer.msr_transfers_id,
				userid: user.user.mlg_users_id,
			});
			setWplyw({ ...wplyw, reload: !wplyw.reload });
		} catch (error) {
			console.error("Error confirming transfer:", error);
		}
	};

	const isBankTransfer =
		wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
			(x) => x.msr_transfers_types_id === transfer.msr_transfers_types_id,
		)?.msr_transfers_types_bank_transfer === 1;

	const canConfirmTransfer = (() => {
		if (!isBankTransfer) return true;
		const accountDigits = (
			transfer?.msr_transfers_account_number || ""
		).replace(/\s+/g, "");
		const accountOwner = (
			transfer?.msr_transfers_account_owner || ""
		).trim();
		return /^\d{26}$/.test(accountDigits) && !!accountOwner;
	})();

	return (
		<div
			style={{
				background: "white",
				borderRadius: "5px",
				border: "1px solid rgb(189, 129, 54)",
				marginTop: "20px",
				overflow: "hidden",
			}}
		>
			<div style={{ padding: "20px" }}>
				<div
					style={{
						display: "flex",
						gap: "20px",
						alignItems: "center",
					}}
				>
					<div
						style={{
							background: "black",
							color: "white",
							padding: "7px 15px",
							fontSize: "16px",
							width: "fit-content",
							borderRadius: "5px",
						}}
					>
						#{index + 1} Wypłata #{transfer?.msr_transfers_own_id}
					</div>
					<LineSpacer />
					<Button onClick={() => setOpen(!open)}>
						{open ? "Zwiń" : "Rozwiń"}
					</Button>
				</div>
				{open && (
					<>
						<div
							style={{
								display: "grid",
								gridTemplateColumns: "1fr 1fr 1fr 1fr",
								alignItems: "end",
								gap: "32px",
								marginTop: "16px",
							}}
						>
							<div>
								<div style={labelStyle}>
									{
										wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
											(x) =>
												x.msr_transfers_types_id ===
												transfer.msr_transfers_types_id,
										)?.msr_transfers_types_amount_title
									}
								</div>
								<div
									style={{
										fontSize: "16px",
										marginTop: "8px",
										fontWeight: "700",
									}}
								>
									{formatPrice(
										transfer.msr_transfers_amount || 0,
									)}{" "}
									zł
								</div>
							</div>
							<div>
								<div style={labelStyle}>
									Przedmiot kwoty wpływu
								</div>
								<div
									style={{
										fontSize: "16px",
										marginTop: "8px",
										fontWeight: "700",
									}}
								>
									{
										wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
											(x) =>
												x.msr_transfers_types_id ===
												transfer.msr_transfers_types_id,
										).msr_transfers_types_name
									}
								</div>
							</div>
							{wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
								(x) =>
									x.msr_transfers_types_id ===
									transfer.msr_transfers_types_id,
							).msr_transfers_types_bank_transfer ? (
								<>
									<div>
										<div style={labelStyle}>
											Numer konta bankowego
										</div>
										<div
											style={{
												fontSize: "16px",
												marginTop: "8px",
												fontWeight: "700",
											}}
										>
											{formatAccountNumber(
												transfer.msr_transfers_account_number,
											)}
										</div>
									</div>
									<div>
										<div style={labelStyle}>
											Imię i nazwisko właściciela konta
										</div>
										<div
											style={{
												fontSize: "16px",
												marginTop: "8px",
												fontWeight: "700",
											}}
										>
											{
												transfer.msr_transfers_account_owner
											}
										</div>
									</div>
								</>
							) : (
								<></>
							)}
						</div>
						{isBankTransfer && (
							<>
								<div
									style={{
										display: "grid",
										gridTemplateColumns: "1fr",
										alignItems: "end",
										gap: "32px",
										marginTop: "16px",
									}}
								>
									<div>
										<div style={labelStyle}>
											Tytuł przelewu
										</div>
										<div
											style={{
												fontSize: "16px",
												marginTop: "8px",
												fontWeight: "700",
											}}
										>
											{updatedTransfertitle}
										</div>
									</div>
								</div>
							</>
						)}
						<WplywSumUp
							wplyw={wplyw}
							personid={selectedPerson.msr_persons_own_id}
							focusedPersonOwnId={deepLink?.personid || null}
						></WplywSumUp>
						<div
							style={{
								marginTop: "16px",
								display: "flex",
								gap: "16px",
								alignItems: "center",
								justifyContent: "end",
							}}
						>
							<LinkToSumUp
								wplywid={wplyw.msr_wplywy_id}
								personid={selectedPerson.msr_persons_own_id}
								transferid={transfer?.msr_transfers_own_id}
								selectedperson={selectedPerson}
							></LinkToSumUp>
							<GeneratePersonRaport
								wplywid={wplyw.msr_wplywy_id}
								personid={selectedPerson.msr_persons_id}
							></GeneratePersonRaport>
							{transfer.msr_transfers_generated_file || !cando ? (
								<></>
							) : !transfer.msr_transfers_confirmed ? (
								!transfer.msr_transfers_id
									.toString()
									.includes("temp") ? (
									<Button
										disabled={!canConfirmTransfer}
										onClick={() => ConfirmTransfer()}
									>
										{wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
											(x) =>
												x.msr_transfers_types_id ===
												transfer.msr_transfers_types_id,
										).msr_transfers_types_bank_transfer
											? "Zatwierdź przelew"
											: "Zatwierdź wypłatę"}
									</Button>
								) : (
									<Button>
										Zapisz wpływ aby zatwierdzić przelew
									</Button>
								)
							) : (
								<>
									{canGenerateXml && (
										<Button
											type="primary"
											onClick={() => GenerateTransfer()}
										>
											Wygeneruj przelew
										</Button>
									)}
									<Button onClick={() => UnconfirmTransfer()}>
										Cofnij zatwierdzenie
									</Button>
								</>
							)}
						</div>
					</>
				)}
			</div>
			<Modal
				open={isGeneratingTransfer}
				footer={null}
				closable={false}
				centered
			>
				<div style={{ textAlign: "center", padding: "20px 0" }}>
					<Spin size="large" />
					<p style={{ marginTop: 20 }}>
						Generowanie pliku XML przelewu, proszę czekać...
					</p>
				</div>
			</Modal>
			{transfer.msr_transfers_generated_file ? (
				<>
					<div
						style={{
							background: "rgb(82, 196, 26)",
							color: "white",
							padding: "10px 20px",
							textAlign: "center",
						}}
					>
						Przelew wygenerowany
					</div>
				</>
			) : !transfer.msr_transfers_confirmed ? (
				<div
					style={{
						background: "#DC0202",
						color: "white",
						padding: "10px 20px",
						textAlign: "center",
					}}
				>
					{wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
						(x) =>
							x.msr_transfers_types_id ===
							transfer.msr_transfers_types_id,
					).msr_transfers_types_bank_transfer
						? "Przelew niezatwierdzony"
						: "Wypłata niezatwierdzona"}
				</div>
			) : (
				<div
					style={{
						background:
							wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
								(x) =>
									x.msr_transfers_types_id ===
									transfer.msr_transfers_types_id,
							).msr_transfers_types_bank_transfer
								? "#BD8136"
								: "rgb(82, 196, 26)",
						color: "white",
						padding: "10px 20px",
						textAlign: "center",
					}}
				>
					{wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types.find(
						(x) =>
							x.msr_transfers_types_id ===
							transfer.msr_transfers_types_id,
					).msr_transfers_types_bank_transfer
						? "Przelew zatwierdzony do generowania"
						: "Wypłata zatwierdzona"}
				</div>
			)}
		</div>
	);
};

export default Transfer;
